`import _ from 'lodash'`
`import XXH from 'xxhashjs'`
`import uuid from 'uuid-random'`

mutations =


  uuid: (state, uuid) ->
    state.uuid = uuid

  currentSentence: (state, currentSentence) ->
    state.currentSentence = currentSentence


  currentWord: (state, currentWord) ->
    state.currentWord = currentWord

  display: (state, display) ->
    state.display = display

  editDisplay: (state, display) ->
    state.display = Object.assign({}, display)

  filters: (state, filters) ->
    state.filters = filters

  resetFilters: (state) ->
    state.filters =
      lemma: {},
      pos: {},
      phonemes: {},
      stressPatterns: {},
      syllables: {},
      videos: {},
      options:
        searchStartsWith: false
        searchEndsWith: false
        searchIsRegex: false
        withVideoOnly: false

  editFilters: (state, filters) ->
    state.filters = Object.assign({}, filters)

  editOneFilter: (state, op) ->
    if op.filterSubName
      Vue.set(state.filters[op.filterName], op.filterSubName, op.filterData)
    else
      Vue.set(state.filters, op.filterName, op.filterData)

  incSentencePlayerRev: (state, sentencePlayerRev) ->
    state.sentencePlayerRev = state.sentencePlayerRev+1

  sentences: (state, sentences) ->
    state.sentences = _.groupBy(sentences, 'for_lemma_pos')

  editSentence: (state, sentence) ->
    idx = _.findIndex(state.sentences[sentence.for_lemma_pos], (sent) => sent.id-0 == sentence.id-0 )
    Vue.set state.sentences[sentence.for_lemma_pos], idx, sentence

  addSentence: (state, sentence) ->
    if !state.sentences[sentence.for_lemma_pos]
      Vue.set(state.sentences, sentence.for_lemma_pos, [sentence])
    else
      state.sentences[sentence.for_lemma_pos].push sentence

  updateSentence: (state, sentence) ->
    idx = _.findIndex(state.sentences[sentence.for_lemma_pos], {id: sentence.id})
    Vue.set(state.sentences[sentence.for_lemma_pos], idx, sentence)

  # LAYOUT

  layout: (state, layout) ->
    state.layout = layout

  layoutBackground: (state, str) ->
    state.layoutBackground = str

  # UUID

  uuid: (state, id) -> state.uuid = state.uuid || id

  # USER

  user: (state, user) ->
    state.user = user

  editVoice: (state, voice) ->
    Vue.set(state.voices, voice.lang, voice.name)

  votes: (state, votes) ->
    state.votes = _.keyBy(votes, 'votable_id')

  addVote: (state, vote) ->
    Vue.set(state.votes, vote.votable_id, vote)

  editVote: (state, vote) ->
    categ = state.votes[vote.votable_id]
    Vue.util.extend(categ, vote)

  deleteVote: (state, vote) ->
    Vue.delete(state.votes, vote.votable_id)

    sentence = state.sentences.find((el) -> el && el.id-0 == vote.votable_id-0)
    Vue.util.extend(sentence, Object.assign(sentence, {votes_nb: sentence.votes_nb - 1}))


`export default mutations`




// WEBPACK FOOTER //
// ./src/store/mutations.coffee